<div class="mobile-header">
    <div class="mobile-header__main">
        <button
            class="button button_with-icon button_size_small button_theme_gray main__button"
            [ngClass]="{ button_theme_task: custCardTabService.isTasksExist }"
            (click)="notificationButtonClick(1)"
        >
            <i class="fa-solid fa-list-check"></i>
            מטלות
        </button>

        <button
            class="button button_with-icon button_size_small button_theme_gray main__button"
            [ngClass]="{ button_theme_comment: custCardTabService.isCommentsExist }"
            (click)="notificationButtonClick(0)"
        >
            <i class="fa-regular fa-pen"></i>
            הערות
        </button>

        <button
            class="button button_with-icon button_size_small main__button"
            [ngClass]="{ button_theme_main: custCardTabService.notificationTab == 2, button_theme_gray: custCardTabService.notificationTab != 2 }"
            (click)="notificationButtonClick(2)"
        >
            <i class="fa-solid fa-user"></i>
            פרטים
        </button>
    </div>

    <div>
    <div class="mobile-header__image-wrapper" [ngClass]="{ 'image-scrolled': isScrolled || isNotificationTabChosen }">
            
        <div class="image-wrapper__image">
            <img
                *ngIf="custcard_3.imagePath && config && custcard_3"
                class="image__avatar"
                [src]="getClientImageSrc()"
                (error)="clearImagePath()"
                alt="Client image"
            />
            <img *ngIf="!custcard_3.imagePath" class="image__avatar" src="/assets/img/client-avatar.png" alt="Client image" />
            <span class="card__vip fa-solid fa-heart" [ngClass]="{ card__vip_active: isVIPCustomer() }"></span>
        </div>

        <!-- <ng-container *ngIf="!isNotificationTabChosen">
            <div class="mobile-header__tags-wrapper">
                <div
                    *ngFor="let tag of customClassificationData"
                    class="tags-wrapper__tag"
                    [ngClass]="{ 'birthday-tag': tag.id == 1, 'debt-tag': tag.id == 2 }"
                >
                    <span *ngIf="tag.id == 1" class="tag__name">{{ tag.name }}</span>
                    <i *ngIf="tag.id == 1" class="fa-solid fa-cake-candles"></i>

                    <span *ngIf="tag.id == 2" class="tag__name">{{ tag.name }}</span>
                    <i *ngIf="tag.id == 2" class="fa-duotone fa-coins"></i>

                    <span *ngIf="tag.id == 3" class="tag__name">{{ tag.name }}</span>
                </div>
            </div>
        </ng-container> -->
        </div>
    </div>
</div>
<div class="card">
    <section class="client__settings-wrapper">
        <div class="client-avatar">
            <img
                *ngIf="custcard_3.imagePath && config && custcard_3"
                class="client__image"
                [src]="getClientImageSrc()"
                (error)="clearImagePath()"
                alt="Client image"
            />
            <img *ngIf="!custcard_3.imagePath" class="client__image client__image_default" src="/assets/img/client-avatar.png" alt="Client image" />
            <span class="card__vip fa-solid fa-heart" [ngClass]="{ card__vip_active: isVIPCustomer() }"></span>
        </div>

        <div class="settings__button-wrapper custom-scrollbar">
            <button
                class="settings__button button button_size_small button_with-icon button_theme_gray"
                (click)="openEditCustomer(custcard_3)"
                [disabled]="isDisabled(21)"
            >
                עריכת לקוח/ה
                <i class="fa-regular fa-user-pen"></i>
            </button>

            <button class="settings__button button button_size_small button_with-icon button_theme_gray" [disabled]="isDisabled(22)">
                קביעת תור חדש
                <i class="fa-regular fa-calendar-lines-pen"></i>
            </button>

            <button class="settings__button button button_size_small button_with-icon button_theme_gray" [disabled]="isDisabled(23)">
                מעבר לחשבון בקופה
                <i class="fa-regular fa-cart-shopping"></i>
            </button>

            <button class="settings__button button button_size_small button_with-icon button_theme_gray" [disabled]="isDisabled(24)">
                שלח הזמנה ל-iTor
                <img class="icon-itor" src="/assets/img/icon-logo-itor.svg" />
            </button>

            <button class="settings__button button button_size_small button_with-icon button_theme_gray" [disabled]="isDisabled(25)">
                שלח לינק מילוי פרטים
                <i class="fa-regular fa-share"></i>
            </button>
        </div>
    </section>
    <section
        class="client__info-wrapper"
        [ngClass]="{
            'client__info-wrapper_hidden': custCardTabService.notificationTabIndex == 0 || custCardTabService.notificationTabIndex == 1
        }"
    >
        <div class="custom-scrollbar">
            <section class="info__section">
                <div class="form__item input-wrapper input-wrapper_with-label">
                    <span class="input-label">שם פרטי</span>
                    <input class="input" [value]="custcard_3.firstName" disabled />
                </div>

                <div class="form__item input-wrapper input-wrapper_with-label">
                    <span class="input-label">שם משפחה</span>
                    <input class="input" [value]="custcard_3.lastName" disabled />
                </div>

                <div class="form__item input-wrapper input-wrapper_with-label">
                    <span class="input-label">מין</span>
                    <input class="input" [value]="sexdesc" disabled />
                </div>

                <div class="form__item input-wrapper input-wrapper_with-label" [ngClass]="{ form__item_blurred: isBlurred(35) }">
                    <span class="input-label">טלפון נייד</span>
                    <input class="input" [value]="custcard_3.pelephone" disabled />
                </div>

                <div class="form__item input-wrapper input-wrapper_with-label" [ngClass]="{ form__item_blurred: isBlurred(36) }">
                    <span class="input-label">טלפון נוסף</span>
                    <input class="input" [value]="custcard_3.phone" disabled />
                </div>

                <div class="form__item input-wrapper input-wrapper_with-label">
                    <span class="input-label">תאריך לידה</span>
                    <input class="input" [value]="custcard_3.birthDay" disabled />
                </div>

                <div class="form__item input-wrapper input-wrapper_with-label" [ngClass]="{ form__item_blurred: isBlurred(40) }">
                    <span class="input-label">כתובת</span>
                    <input class="input" [value]="custcard_3.address" disabled />
                </div>

                <div class="form__item input-wrapper input-wrapper_with-label" [ngClass]="{ form__item_blurred: isBlurred(41) }">
                    <span class="input-label">ישוב</span>
                    <input class="input" [value]="custcard_3.cityName" disabled />
                </div>

                <div class="form__item input-wrapper input-wrapper_with-label" [ngClass]="{ form__item_blurred: isBlurred(39) }">
                    <span class="input-label">דואר אלקטרוני</span>
                    <input class="input" [value]="custcard_3.email" disabled />
                </div>

                <div class="form__item input-wrapper input-wrapper_with-label">
                    <span class="input-label">מקור הגעה</span>
                    <input class="input" [value]="custcard_3.sourceName" disabled />
                </div>

                <div class="form__item input-wrapper input-wrapper_with-label">
                    <span class="input-label">לקוח ממליץ</span>
                    <input class="input" [value]="custcard_3.recommenderfl" disabled />
                </div>

                <div class="form__item input-wrapper input-wrapper_with-label">
                    <span class="input-label">מטפל מועדף</span>
                    <input class="input" [value]="custcard_3.saparName" disabled />
                </div>
            </section>

            <section *ngIf="categoriesArray.length" class="info__section">
                <span class="section__name">תיוגים</span>
                <div class="categories__tags">
                    <div *ngFor="let item of categoriesArray" class="tag">
                        <span class="tag__text">{{ item.custCategoryName }}</span>
                    </div>
                </div>
            </section>

            <section class="info__section">
                <span class="section__name">מידע נוסף</span>

                <div class="form__item input-wrapper input-wrapper_with-label" [ngClass]="{ form__item_blurred: isBlurred(38) }">
                    <span class="input-label">.ת.ז</span>
                    <input class="input" [value]="custcard_3.identicalNum" disabled />
                </div>

                <div class="form__item input-wrapper input-wrapper_with-label">
                    <span class="input-label">עיסוק לקוח</span>
                    <input class="input" [value]="custcard_3.occupationName" disabled />
                </div>

                <div class="form__item input-wrapper input-wrapper_with-label">
                    <span class="input-label">יום נישואין</span>
                    <input class="input" [value]="custcard_3.wedding_Date" disabled />
                </div>

                <div class="form__item input-wrapper input-wrapper_with-label" [ngClass]="{ form__item_blurred: isBlurred(37) }">
                    <span class="input-label">טלפון נוסף</span>
                    <input class="input" [value]="custcard_3.aditionalPhone" disabled />
                </div>

                <div class="form__item form__item_width-2 input-wrapper input-wrapper_with-label">
                    <span class="input-label">סוג שתייה מועדף</span>
                    <input class="input" [value]="custcard_3.kindDrink" disabled />
                </div>
            </section>

            <section *ngIf="custcard_3.faceBook || custcard_3.instLink" class="info__section section__contacts">
                <span class="section__name">רשתות חברתיות</span>

                <a
                    *ngIf="custcard_3.instLink && isInstLinkValid"
                    href="https://instagram.com/{{ custcard_3.instLink }}"
                    class="button-icon button-instagram"
                    target="_blank"
                ></a>

                <button
                    *ngIf="custcard_3.instLink && !isInstLinkValid"
                    class="button-icon button-instagram"
                    [disabled]="isDisabled(34)"
                    (click)="invalidLink()"
                ></button>

                <a
                    *ngIf="custcard_3.faceBook && isFbLinkValid"
                    href="https://facebook.com/{{ custcard_3.faceBook }}"
                    class="button-icon button-facebook"
                    target="_blank"
                ></a>

                <button
                    *ngIf="custcard_3.faceBook && !isFbLinkValid"
                    class="button-icon button-facebook"
                    [disabled]="isDisabled(33)"
                    (click)="invalidLink()"
                ></button>
            </section>

            <section class="info__section">
                <div class="checkbox-label">
                    הודעות ותזכורות נשלחות ללקוח/ה
                    <input class="checkbox" [(ngModel)]="custcard_3.isSendSMS" type="checkbox" tabindex="-1" />
                    <span class="custom-checkbox"></span>
                </div>

                <span *ngIf="custcard_3.isBlockedMarketingMessages" class="info__warning">
                    <i class="fa-solid fa-ban info__warning-icon"></i>
                    הלקוח/ה חסמ/ה קבלת תוכן שיווקי
                </span>
            </section>
        </div>
    </section>

    <app-custcardview5
        class="notifications"
        [ngClass]="{
            notifications_visible: custCardTabService.notificationTabIndex == 0 || custCardTabService.notificationTabIndex == 1
        }"
        [customerId]="customerId"
    ></app-custcardview5>
</div>

<p-messages class="messages"></p-messages>
